import { type ReactNode, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { useMount } from 'react-use';
import { useAuth } from '@/core/auth';
import i18n, { DEFAULT_LOCALE, ensureI18n } from '@/core/i18n/i18n';

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const { user } = useAuth();
  const [mounted, setMounted] = useState(false);

  useMount(() => {
    (async () => {
      ensureI18n();
      const stored = localStorage.getItem('selectedLocale');
      const initial = (user?.language ||
        stored ||
        DEFAULT_LOCALE) as import('@/core/i18n/i18n').Locale;
      await i18n.changeLanguage(initial);
      const htmlEl = document.querySelector('html');
      if (htmlEl) htmlEl.lang = initial;
      setMounted(true);
    })();
  });

  useEffect(() => {
    if (!mounted) return;
    const next = (user?.language ||
      localStorage.getItem('selectedLocale') ||
      DEFAULT_LOCALE) as import('@/core/i18n/i18n').Locale;
    if (i18n.language !== next) {
      i18n.changeLanguage(next);
      const htmlEl = document.querySelector('html');
      if (htmlEl) htmlEl.lang = next;
    }
  }, [mounted, user]);

  return (
    <I18nextProvider i18n={i18n}>
      {mounted ? children : null}
      <div className={!mounted ? 'fixed inset-0 z-49' : ''} />
    </I18nextProvider>
  );
}
